<div class="fixed inset-0 bg-black/50 flex items-center justify-center max-[576px]:items-end z-[100]"
    *ngIf="isOpen && currentView === 'main'">
    <div
        class="bg-white rounded-2xl p-[30px] !pr-4 w-full max-w-xl relative deposit-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none max-[576px]:p-5 max-[576px]:pb-[calc(1.25rem+env(safe-area-inset-bottom))]">
        <button
            class="w-[37px] h-[37px] text-[#000000cc] flex items-center justify-center absolute -top-3 -right-3 max-[576px]:top-3 max-[576px]:right-3 bg-[#E9E9E9] hover:bg-[#000000cc] hover:text-white duration-300 ease-in-out rounded-full cursor-pointer"
            (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                    stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
        <div
            class="max-h-[calc(100vh-100px)] max-[576px]:max-h-[75vh] overflow-y-auto overflow-x-hidden pr-3 custom-scroll">
            <div class="flex flex-col border-b border-secondary-button-black pb-6">
                <h2 class="text-black text-2xl font-bold mb-2 max-[576px]:text-base">Deposit to Prediction-market </h2>
                <p class="text-base text-secondary-text-black font-medium max-[576px]:text-sm">Prediction-market Balance: ${{usdcBalance |
                    number:'1.2-2'}}</p>
            </div>
            <div class="flex flex-col py-6">
                <div class="relative" *ngIf="userData?.user_type !== 'WEB2'">
                    <input type="text" placeholder="Enter the Amount" [(ngModel)]="depositAmount" appWholeNumberOnly
                        class="w-full text-black font-medium !leading-3 border border-secondary-button-black placeholder:text-[#00000059] placeholder:font-normal focus:border-black rounded-xl px-4 py-4 !pr-28">
                    <button (click)="handleDeposit()" [disabled]="isDepositProcessing()"
                        class="text-black font-syne text-xs bg-secondary-button-black font-semibold absolute right-2.5 top-2.5 border-[0.5px] border-secondary-button-black rounded-[7px] cursor-pointer hover:text-white hover:bg-black duration-300 ease-in-out px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed">
                        {{ isDepositProcessing() ? 'Processing...' : 'Continue' }}
                    </button>
                </div>
                <button (click)="handleTransakDeposit()" [disabled]="isTransakProcessing()"
                    class="w-full mt-4 text-black font-syne text-sm bg-white font-semibold border border-secondary-button-black rounded-[7px] cursor-pointer hover:text-white hover:bg-black duration-300 ease-in-out px-4 py-3 disabled:opacity-50 disabled:cursor-not-allowed">
                    {{ isTransakProcessing() ? 'Processing...' : 'Buy USDC via Transak' }}
                </button>
                <!-- Error Message -->
                <!-- <p *ngIf="depositAmount > usdcBalance"
                    class="text-red-500 text-xs mt-2 font-medium">
                    Insufficient balance
                </p> -->


                <!-- <div class="flex items-center justify-between gap-3.5 border-b border-secondary-button-black py-6">
                    <div class="flex items-center gap-3.5">
                        <span class="block bg-[#1cae911a] rounded-[10px] p-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"
                                fill="none">
                                <path
                                    d="M32.6673 17.5007C32.6673 25.8769 25.8769 32.6673 17.5007 32.6673C9.12433 32.6673 2.33398 25.8769 2.33398 17.5007C2.33398 9.12433 9.12433 2.33398 17.5007 2.33398C25.8769 2.33398 32.6673 9.12433 32.6673 17.5007Z"
                                    stroke="#1CAE91" stroke-width="2.275" />
                                <path
                                    d="M18.6966 10.2168L15.0577 15.7216C14.5706 16.4586 14.3271 16.827 14.478 17.1115C14.6288 17.3958 15.068 17.3957 15.9462 17.3957H19.0742C19.9525 17.3957 20.3917 17.3957 20.5424 17.68C20.6934 17.9645 20.4499 18.3329 19.9628 19.0699L16.3239 24.5747"
                                    stroke="#1CAE91" stroke-width="2.27523" stroke-linecap="round" />
                            </svg>
                        </span>
                        <div class="flex flex-col gap-1.5">
                            <h3 class="text-black text-xl font-medium">Transfer Crypto</h3>
                            <p class="text-base text-secondary-text-black font-medium">No Limit | Instant</p>
                        </div>
                    </div>
                    <button class="text-secondary-text-black hover:text-black duration-200 ease-in-out cursor-pointer"
                        (click)="openTransferCrypto()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                            <path
                                d="M0.599675 0.600097C0.599675 0.600097 8.59961 6.49196 8.59961 8.6001C8.59961 10.7084 0.599609 16.6001 0.599609 16.6001"
                                stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                </div> -->

                <!-- <div class="flex items-center justify-between gap-3.5 border-b border-secondary-button-black py-6">
                    <div class="flex items-center gap-3.5">
                        <span class="block bg-[#1cae911a] rounded-[10px] p-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"
                                fill="none">
                                <path
                                    d="M2.91602 17.5007C2.91602 12.3418 2.91602 9.7624 4.45135 8.0403C4.69692 7.76486 4.96757 7.51012 5.26023 7.279C7.08996 5.83398 9.83059 5.83398 15.3118 5.83398H19.6868C25.1681 5.83398 27.9088 5.83398 29.7384 7.279C30.0311 7.51012 30.3018 7.76486 30.5473 8.0403C32.0827 9.7624 32.0827 12.3418 32.0827 17.5007C32.0827 22.6595 32.0827 25.2389 30.5473 26.961C30.3018 27.2365 30.0311 27.4911 29.7384 27.7223C27.9088 29.1673 25.1681 29.1673 19.6868 29.1673H15.3118C9.83059 29.1673 7.08996 29.1673 5.26023 27.7223C4.96757 27.4911 4.69692 27.2365 4.45135 26.961C2.91602 25.2389 2.91602 22.6595 2.91602 17.5007Z"
                                    stroke="#1CAE91" stroke-width="2.1875" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M14.584 23.334H16.7715" stroke="#1CAE91" stroke-width="2.1875"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21.1465 23.334H26.2507" stroke="#1CAE91" stroke-width="2.1875"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2.91602 13.125H32.0827" stroke="#1CAE91" stroke-width="2.1875"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                        <div class="flex flex-col gap-1.5">
                            <h3 class="text-black text-xl font-medium">Deposite with Card</h3>
                            <p class="text-base text-secondary-text-black font-medium">$50,000 Limit | 5 min</p>
                        </div>
                    </div>
                    <button class="text-secondary-text-black hover:text-black duration-200 ease-in-out cursor-pointer"
                        (click)="openDepositWithCard()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                            <path
                                d="M0.599675 0.600097C0.599675 0.600097 8.59961 6.49196 8.59961 8.6001C8.59961 10.7084 0.599609 16.6001 0.599609 16.6001"
                                stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                </div> -->

                <!-- <div class="flex items-center justify-between gap-3.5 py-6">
                    <div class="flex items-center gap-3.5">
                        <span class="block bg-[#1cae911a] rounded-[10px] p-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"
                                fill="none">
                                <path
                                    d="M9.17879 7.05038L6.07477 25.7698C5.81337 27.3463 5.68266 28.1345 6.1173 28.6504C6.55194 29.166 7.34699 29.166 8.9371 29.166H9.52397C10.7239 29.166 11.3239 29.166 11.733 28.8095C12.1421 28.4527 12.2269 27.8559 12.3966 26.6618L13.0784 21.8647C13.1323 21.4854 13.1593 21.2958 13.2017 21.1335C13.5054 19.9709 14.4876 19.1147 15.6756 18.9769C15.8414 18.9577 16.032 18.9577 16.4132 18.9577H18.1078C22.6213 18.9577 26.534 15.8183 27.5344 11.3945C28.5163 7.0515 25.2322 2.91602 20.801 2.91602H14.0344C12.4101 2.91602 11.5979 2.91602 10.9583 3.25843C10.5926 3.45424 10.2728 3.72651 10.0205 4.05694C9.57934 4.63475 9.44583 5.43995 9.17879 7.05038Z"
                                    stroke="#1CAE91" stroke-width="2.1875" />
                                <path
                                    d="M12.0206 28.4397L11.6872 30.3832C11.5344 31.2734 12.2279 32.0855 13.1408 32.0855H16.0436C16.7645 32.0855 17.3796 31.5701 17.498 30.8669L18.5617 24.5541C18.6803 23.851 19.2954 23.3355 20.0161 23.3355H22.6457C26.4098 23.3355 29.6688 20.7497 30.4854 17.1153C31.057 14.5713 29.8131 12.1211 27.7077 10.9414"
                                    stroke="#1CAE91" stroke-width="2.1875" />
                            </svg>
                        </span>
                        <div class="flex flex-col gap-1.5">
                            <h3 class="text-black text-xl font-medium">Deposit with Paypal</h3>
                            <p class="text-base text-secondary-text-black font-medium">$50,000 Limit | 5 min</p>
                        </div>
                    </div>
                    <button class="text-secondary-text-black hover:text-black duration-200 ease-in-out cursor-pointer"
                        (click)="openDepositWithPaypal()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                            <path
                                d="M0.599675 0.600097C0.599675 0.600097 8.59961 6.49196 8.59961 8.6001C8.59961 10.7084 0.599609 16.6001 0.599609 16.6001"
                                stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                </div> -->
            </div>
        </div>
    </div>
</div>

<!-- Transfer Crypto -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center max-[576px]:items-end z-[100]"
    *ngIf="isOpen && currentView === 'transfer'">
    <div
        class="bg-white rounded-2xl p-[30px] !pr-4 w-full max-w-[528px] relative deposit-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none max-[576px]:p-5 max-[576px]:pb-[calc(1.25rem+env(safe-area-inset-bottom))]">

        <div
            class="max-h-[calc(100vh-100px)] max-[576px]:max-h-[75vh] overflow-y-auto overflow-x-hidden pr-3 custom-scroll">
            <div class="flex flex-col gap-6">
                <div class="flex items-start gap-4">
                    <button class="relative top-0.5 cursor-pointer" (click)="goBack()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path d="M14.9999 19C14.9999 19 9 14.2129 9 12.5C9 10.787 15 6 15 6" stroke="black"
                                stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                    <div class="flex flex-col">
                        <h2 class="text-black text-2xl font-bold mb-2">Transfer Crypto</h2>
                        <p class="text-base text-secondary-text-black font-medium">BlockchainX Balance: ${{usdcBalance |
                            number:'1.2-2'}}
                        </p>
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-6">
                    <div class="relative border border-secondary-button-black py-3 px-[18px] current-value-dropdown"
                        [ngClass]="{'rounded-lg': !isListOpen,'rounded-t-lg': isListOpen}">
                        <p class="text-xs font-medium text-secondary-text-black mb-1">
                            Supported Token
                        </p>

                        <!-- Selected value -->
                        <div class="flex items-center justify-between cursor-pointer" (click)="toggleDropdown($event)">
                            <div class="flex items-center gap-2.5">
                                <img [src]="'../../../../assets/images/deposit/' + selectedCurrency.icon" alt="" />
                                <p class="text-black text-lg font-semibold">
                                    {{ selectedCurrency.code }}
                                </p>
                            </div>

                            <button type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                    fill="none" class="transition-transform duration-200"
                                    [ngClass]="{ 'rotate-x-180': isListOpen }">
                                    <path d="M20.5 8C20.5 8 16.8176 13 15.5 13C14.1823 13 10.5 8 10.5 8" stroke="black"
                                        stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>

                        <!-- Dropdown -->
                        <ul *ngIf="isListOpen" class="absolute left-0 top-full z-20 mt-px w-full bg-white border border-secondary-button-black border-t-0
                            rounded-b-lg px-[18px] shadow-lg">
                            <li *ngFor="let item of currencies"
                                class="flex items-center justify-between py-3.5 border-b border-secondary-button-black last:border-b-0 cursor-pointer"
                                (click)="selectCurrency(item)">
                                <div class="flex items-center gap-2.5">
                                    <img [src]="'../../../../assets/images/deposit/' + item.icon"
                                        class="w-[18px] h-[18px] rounded-full" />
                                    <p class="text-black text-base font-medium">
                                        {{ item.code }}
                                    </p>
                                </div>

                                <!-- Selected icon -->
                                <svg *ngIf="selectedCurrency.code === item.code" xmlns="http://www.w3.org/2000/svg"
                                    width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M12.4993 2.04813C11.7102 1.80025 10.8703 1.66663
                                    9.99935 1.66663C5.39697 1.66663 1.66602 5.39758
                                    1.66602 9.99996C1.66602 14.6023 5.39697 18.3333
                                    9.99935 18.3333C14.6017 18.3333 18.3327 14.6023
                                    18.3327 9.99996C18.3327 9.12896 18.199 8.28916
                                    17.9512 7.49996" stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path d="M7.08398 7.91667L10.0007 10.8333L17.5008 2.5" stroke="black"
                                        stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </li>
                        </ul>
                    </div>

                    <div class="relative border border-secondary-button-black py-3 px-[18px] current-value-dropdown"
                        [ngClass]="{'rounded-lg': !isChainOpen,'rounded-t-lg': isChainOpen}">

                        <!-- Header -->
                        <div class="flex items-center justify-between mb-1">
                            <p class="text-xs font-medium text-secondary-text-black">
                                Supported Chain
                            </p>

                            <p class="flex items-center gap-1 text-[10px] text-secondary-text-black font-medium">
                                Min $20
                                <span class="cursor-pointer">
                                    <!-- info icon -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"
                                        fill="none">
                                        <g clip-path="url(#clip0_4694_29820)">
                                            <path
                                                d="M4.9987 9.16732C7.29988 9.16732 9.16537 7.30184 9.16537 5.00065C9.16537 2.69946 7.29988 0.833984 4.9987 0.833984C2.69751 0.833984 0.832031 2.69946 0.832031 5.00065C0.832031 7.30184 2.69751 9.16732 4.9987 9.16732Z"
                                                stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M5 6.66602V4.79102" stroke="black" stroke-opacity="0.5"
                                                stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M5 3.33845V3.33398" stroke="black" stroke-opacity="0.5"
                                                stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_4694_29820">
                                                <rect width="10" height="10" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                            </p>
                        </div>

                        <!-- Selected -->
                        <div class="flex items-center justify-between cursor-pointer"
                            (click)="toggleChainDropdown($event)">
                            <div class="flex items-center gap-2.5">
                                <img [src]="'../../../../assets/images/deposit/' + selectedChain.icon" />
                                <p class="text-black text-lg font-semibold">
                                    {{ selectedChain.name }}
                                </p>
                            </div>

                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                fill="none" class="transition-transform duration-200"
                                [ngClass]="{ 'rotate-x-180': isChainOpen }">
                                <path d="M20.5 8.00004C20.5 8.00004 16.8176 13 15.5 13C14.1823 13 10.5 8 10.5 8"
                                    stroke="black" stroke-opacity="0.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>

                        <!-- Dropdown -->
                        <ul *ngIf="isChainOpen" class="absolute left-0 top-full mt-px w-full bg-white border border-secondary-button-black border-t-0
                            rounded-b-lg z-50 shadow-lg px-[18px]">
                            <li *ngFor="let item of chains"
                                class="flex items-center justify-between py-3.5 border-b border-secondary-button-black cursor-pointer last:border-b-0"
                                (click)="selectChain(item)">
                                <div class="flex items-center gap-2.5">
                                    <img [src]="'../../../../assets/images/deposit/' + item.icon"
                                        class="w-[18px] h-[18px]" />
                                    <p class="text-black text-base font-medium">
                                        {{ item.name }}
                                    </p>
                                </div>

                                <!-- ✅ Check icon -->
                                <span *ngIf="selectedChain.name === item.name">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                                        <path
                                            d="M12.4993 2.04813C11.7102 1.80025 10.8703 1.66663 9.99935 1.66663C5.39697 1.66663 1.66602 5.39758 1.66602 9.99996C1.66602 14.6023 5.39697 18.3333 9.99935 18.3333C14.6017 18.3333 18.3327 14.6023 18.3327 9.99996C18.3327 9.12896 18.199 8.28916 17.9512 7.49996"
                                            stroke="black" stroke-opacity="0.8" stroke-width="1.5"
                                            stroke-linecap="round" />
                                        <path d="M7.08398 7.91667L10.0007 10.8333L17.5008 2.5" stroke="black"
                                            stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </li>
                        </ul>

                    </div>

                </div>

                <div class="w-[250px] mx-auto border border-secondary-button-black rounded-[15px] p-5">
                    <img *ngIf="qrCodeDataUrl" [src]="qrCodeDataUrl" alt="QR Code"
                        class="w-full h-full object-contain" />
                    <img *ngIf="!qrCodeDataUrl" src="../../../../assets/images/deposit/scanner.svg" />
                </div>

                <div class="flex flex-col gap-1.5 border border-secondary-button-black rounded-lg py-4 px-[18px]">
                    <div class="flex justify-between">
                        <p class="text-xs font-medium text-secondary-text-black">Your deposit address</p>
                        <p class="flex items-center gap-1 text-[10px] font-medium text-secondary-text-black">
                            Terms apply
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"
                                fill="none">
                                <g clip-path="url(#clip0_4694_29847)">
                                    <path
                                        d="M4.9987 9.16732C7.29988 9.16732 9.16537 7.30184 9.16537 5.00065C9.16537 2.69946 7.29988 0.833984 4.9987 0.833984C2.69751 0.833984 0.832031 2.69946 0.832031 5.00065C0.832031 7.30184 2.69751 9.16732 4.9987 9.16732Z"
                                        stroke="black" stroke-opacity="0.5" stroke-width="0.875" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M5 6.66602V4.79102" stroke="black" stroke-opacity="0.5"
                                        stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5 3.33845V3.33398" stroke="black" stroke-opacity="0.5"
                                        stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_4694_29847">
                                        <rect width="10" height="10" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </p>
                    </div>
                    <div class="flex items-center justify-between gap-4">
                        <h2 class="text-lg font-semibold text-black !leading-3">{{userData.proxy_wallet | truncate: 18 :
                            10}}
                        </h2>
                        <button (click)="copyText()" class="hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none">
                                <path
                                    d="M7.5 12.5C7.5 10.143 7.5 8.9645 8.23223 8.23223C8.9645 7.5 10.143 7.5 12.5 7.5H13.3333C15.6903 7.5 16.8688 7.5 17.6011 8.23223C18.3333 8.9645 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6903 18.3333 16.8688 17.6011 17.6011C16.8688 18.3333 15.6903 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.9645 18.3333 8.23223 17.6011C7.5 16.8688 7.5 15.6903 7.5 13.3333V12.5Z"
                                    stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M14.1659 7.49935C14.1639 5.03511 14.1267 3.75869 13.4093 2.88471C13.2708 2.71592 13.1161 2.56117 12.9473 2.42265C12.0253 1.66602 10.6556 1.66602 7.91602 1.66602C5.17645 1.66602 3.80667 1.66602 2.88471 2.42265C2.71592 2.56116 2.56117 2.71592 2.42265 2.88471C1.66602 3.80667 1.66602 5.17645 1.66602 7.91602C1.66602 10.6556 1.66602 12.0253 2.42265 12.9473C2.56116 13.1161 2.71592 13.2708 2.88471 13.4093C3.75869 14.1267 5.03511 14.1639 7.49935 14.1659"
                                    stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="grid grid-cols-3 gap-7 border border-secondary-button-black rounded-lg py-4 px-[18px]">
                    <div class="flex flex-col gap-3">
                        <p class="text-secondary-text-black text-xs font-medium !leading-2.5">Price Impact</p>
                        <h2 class="flex items-center gap-2 !leading-3">
                            &lt;0.25%
                            <span class="cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"
                                    fill="none">
                                    <g clip-path="url(#clip0_4694_29864)">
                                        <path
                                            d="M4.9987 9.16732C7.29988 9.16732 9.16537 7.30184 9.16537 5.00065C9.16537 2.69946 7.29988 0.833984 4.9987 0.833984C2.69751 0.833984 0.832031 2.69946 0.832031 5.00065C0.832031 7.30184 2.69751 9.16732 4.9987 9.16732Z"
                                            stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5 6.66602V4.79102" stroke="black" stroke-opacity="0.5"
                                            stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5 3.33845V3.33398" stroke="black" stroke-opacity="0.5"
                                            stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4694_29864">
                                            <rect width="10" height="10" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </h2>
                    </div>
                    <div class="flex flex-col gap-3">
                        <p class="text-secondary-text-black text-xs font-medium !leading-2.5">Max Slippage</p>
                        <h2 class="flex items-center gap-2 !leading-3">
                            Auto · 1.00%
                            <span class="cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"
                                    fill="none">
                                    <g clip-path="url(#clip0_4694_29864)">
                                        <path
                                            d="M4.9987 9.16732C7.29988 9.16732 9.16537 7.30184 9.16537 5.00065C9.16537 2.69946 7.29988 0.833984 4.9987 0.833984C2.69751 0.833984 0.832031 2.69946 0.832031 5.00065C0.832031 7.30184 2.69751 9.16732 4.9987 9.16732Z"
                                            stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5 6.66602V4.79102" stroke="black" stroke-opacity="0.5"
                                            stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5 3.33845V3.33398" stroke="black" stroke-opacity="0.5"
                                            stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4694_29864">
                                            <rect width="10" height="10" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </h2>
                    </div>
                    <div class="flex flex-col gap-3">
                        <p class="text-secondary-text-black text-xs font-medium !leading-3">Processing time:</p>
                        <h2 class="flex items-center gap-2 !leading-3">
                            30 Min
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Deposit With Card -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center max-[576px]:items-end z-[100]"
    *ngIf="isOpen && currentView === 'card'">
    <div
        class="bg-white rounded-2xl p-[30px] !pr-4 w-full max-w-[528px] relative deposit-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none max-[576px]:p-5 max-[576px]:pb-[calc(1.25rem+env(safe-area-inset-bottom))]">
        <div
            class="max-h-[calc(100vh-100px)] max-[576px]:max-h-[75vh] overflow-y-auto overflow-x-hidden pr-3 custom-scroll">
            <div class="flex flex-col gap-6">
                <div class="flex items-start gap-4">
                    <!-- Back button -->
                    <button class="relative top-0.5 cursor-pointer" (click)="goBack()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path d="M14.9999 19C14.9999 19 9 14.2129 9 12.5C9 10.787 15 6 15 6" stroke="black"
                                stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                    <div class="flex flex-col">
                        <h2 class="text-black text-2xl font-bold mb-2">Deposit With Card</h2>
                        <p class="text-base text-secondary-text-black font-medium">BlockchainX Balance: ${{usdcBalance |
                            number:'1.2-2'}}
                        </p>
                    </div>
                </div>

                <div class="flex flex-col gap-2 border border-secondary-button-black rounded-lg py-3 px-[18px]">
                    <button class="flex items-center gap-2 cursor-pointer">
                        USD
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                            <path d="M10.5 0.500041C10.5 0.500041 6.81758 5.5 5.5 5.5C4.18233 5.5 0.5 0.5 0.5 0.5"
                                stroke="black" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <div class="flex justify-between">
                        <div class="flex items-center gap-2 w-[calc(100%-250px)]">
                            <p class="text-black text-[22px] font-semibold !leading-4">$</p>
                            <input type="text" placeholder="0" [(ngModel)]="depositAmount" appWholeNumberOnly
                                class="w-full text-black text-[22px] font-semibold placeholder:text-secondary-text-black border-0 outline-none p-0" />
                        </div>
                        <ul class="flex items-center gap-2.5">
                            <li class="text-black text-base font-medium !leading-5 cursor-pointer w-[70px] h-8 bg-light-black-300 text-center p-2 rounded hover:bg-gray-200 transition-colors"
                                (click)="setAmount('100')">
                                $100
                            </li>
                            <li class="text-black text-base font-medium !leading-5 cursor-pointer w-[70px] h-8 bg-light-black-300 text-center p-2 rounded hover:bg-gray-200 transition-colors"
                                (click)="setAmount('500')">
                                $500
                            </li>
                            <li class="text-black text-base font-medium !leading-5 cursor-pointer w-[70px] h-8 bg-light-black-300 text-center p-2 rounded hover:bg-gray-200 transition-colors"
                                (click)="setAmount('1000')">
                                $1,000
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="flex flex-col gap-3 border border-secondary-button-black rounded-lg py-3 px-[18px]">
                    <div class="flex justify-between">
                        <p class="text-xs font-medium text-secondary-text-black !leading-2.5">Provider</p>
                        <p class="text-[#00000080] text-[10px] font-medium !leading-2.5">Auto-Picked For you</p>
                    </div>
                    <div class="flex justify-between">
                        <div class="flex items-center gap-2.5">
                            <img src="../../../../assets/images/deposit/moonpay.svg" alt="MoonPay"
                                class="w-5 h-5 rounded-full" />
                            <p class="text-black text-lg font-semibold">MoonPay</p>
                        </div>
                        <button>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                fill="none">
                                <path d="M20.5 8.00004C20.5 8.00004 16.8176 13 15.5 13C14.1823 13 10.5 8 10.5 8"
                                    stroke="black" stroke-opacity="0.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>

                <button
                    class="text-white font-syne text-sm font-semibold rounded-lg py-3 px-4 transition-all duration-200"
                    [ngClass]="isDepositProcessing() ? 'bg-gray-400 cursor-not-allowed' : 'bg-black hover:bg-gray-800'"
                    [disabled]="isDepositProcessing()" (click)="handleDeposit()">
                    {{ isDepositProcessing() ? 'Processing...' : 'Continue' }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Processing View with loading animation -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center max-[576px]:items-end z-[100]"
    *ngIf="isOpen && currentView === 'processing'">
    <div
        class="bg-white rounded-2xl p-[30px] !pr-4 w-full max-w-xl relative deposit-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none max-[576px]:p-5 max-[576px]:pb-[calc(1.25rem+env(safe-area-inset-bottom))]">
        <!-- <button
            class="w-[37px] h-[37px] text-[#000000cc] flex items-center justify-center absolute -top-3 -right-3 bg-[#E9E9E9] hover:bg-[#000000cc] hover:text-white duration-300 ease-in-out rounded-full cursor-pointer"
            (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                    stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button> -->
        <div class="flex flex-col items-center justify-center">
            <!-- Loading animation -->
            <div class="inline-block rounded-xl bg-[#1cae911a] p-4 mb-3 animate-pulse">
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
                    <path
                        d="M41.6232 22.2996C41.6232 32.9726 32.9709 41.6249 22.2979 41.6249C11.6249 41.6249 2.97266 32.9726 2.97266 22.2996C2.97266 11.6266 11.6249 2.97437 22.2979 2.97437C32.9709 2.97437 41.6232 11.6266 41.6232 22.2996Z"
                        stroke="#1CAE91" stroke-width="2.89879" />
                    <path
                        d="M23.8245 13.0195L19.1878 20.0337C18.5671 20.9728 18.2569 21.4422 18.4492 21.8047C18.6413 22.1669 19.2009 22.1669 20.32 22.1669H24.3056C25.4247 22.1669 25.9843 22.1669 26.1764 22.5291C26.3688 22.8916 26.0585 23.361 25.4378 24.3001L20.8011 31.3143"
                        stroke="#1CAE91" stroke-width="2.89908" stroke-linecap="round" />
                </svg>
            </div>
            <h2 class="text-black text-lg font-semibold mb-1">Deposit received and Processing.....</h2>
            <p class="text-base text-secondary-text-black">Your Deposit will be credited to your account shortly </p>
            <!-- Loading dots animation -->
            <div class="flex space-x-1 mt-4">
                <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: -0.32s;"></div>
                <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: -0.16s;"></div>
                <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
            </div>
        </div>
    </div>
</div>

<!-- Completed -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center max-[576px]:items-end z-[100]"
    *ngIf="isOpen && currentView === 'completed'">
    <div
        class="bg-white rounded-2xl p-[30px] !pr-4 w-full max-w-xl relative deposit-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none max-[576px]:p-5 max-[576px]:pb-[calc(1.25rem+env(safe-area-inset-bottom))]">
        <button
            class="w-[37px] h-[37px] text-[#000000cc] flex items-center justify-center absolute -top-3 -right-3 max-[576px]:top-3 max-[576px]:right-3 bg-[#E9E9E9] hover:bg-[#000000cc] hover:text-white duration-300 ease-in-out rounded-full cursor-pointer"
            (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                    stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
        <div class="flex flex-col items-center justify-center">
            <span class="inline-block rounded-xl bg-[#1cae911a] p-4 mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
                    <path
                        d="M22.9343 3.75633C21.4864 3.30156 19.9456 3.0564 18.3476 3.0564C9.9037 3.0564 3.05859 9.9015 3.05859 18.3454C3.05859 26.7892 9.9037 33.6344 18.3476 33.6344C26.7914 33.6344 33.6366 26.7892 33.6366 18.3454C33.6366 16.7474 33.3913 15.2066 32.9366 13.7587"
                        stroke="#1CAE91" stroke-width="2.29335" stroke-linecap="round" />
                    <path d="M12.9961 14.524L18.3472 19.8752L32.1076 4.58618" stroke="#1CAE91" stroke-width="2.29335"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </span>
            <h2 class="text-black text-lg font-semibold mb-1">Deposit Completed</h2>
            <p class="text-base text-secondary-text-black">Your Deposit amount has been credited to your account.</p>
        </div>
    </div>
</div>

<!-- Transak iFrame View -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center max-[576px]:items-end z-[100]"
    *ngIf="isOpen && currentView === 'transak'">
    <div class="bg-white rounded-2xl w-full max-w-2xl relative deposit-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none"
        style="height: 85vh;">
        <!-- Header -->
        <div class="flex items-center gap-3 px-5 py-4 border-b border-secondary-button-black max-[576px]:mt-4">
            <button class="cursor-pointer text-secondary-text-black hover:text-black duration-200"
                (click)="currentView = 'main'">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path d="M14.9999 19C14.9999 19 9 14.2129 9 12.5C9 10.787 15 6 15 6" stroke="black"
                        stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
            <h2 class="text-black text-lg font-bold flex-1 max-[576px]:text-sm">Buy USDC via Transak</h2>
            <!-- Close -->
            <button
                class="w-[37px] h-[37px] text-[#000000cc] flex items-center justify-center bg-[#E9E9E9] hover:bg-[#000000cc] hover:text-white duration-300 ease-in-out rounded-full cursor-pointer"
                (click)="close()">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                        stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        <!-- iFrame -->
        <iframe *ngIf="transakUrl()" [src]="transakUrl()" allow="camera; microphone; payment"
            class="w-full rounded-b-2xl" style="height: calc(100% - 65px); border: none;">
        </iframe>
    </div>
</div>